import {Flex, Text, Image, FlexProps} from '@chakra-ui/react';
import {useTranslate} from '@eksab/i18n';
import {useIntl} from 'react-intl';
import targetImg from '../icons/target.png';
import {QuestionTimer} from './QuestionTimer';
import {useTriviaStore} from '../state';

interface QuizHeaderProps extends FlexProps {
  onTimeOut: () => void;
  isTimerPaused: boolean;
}

export function QuizHeader({onTimeOut, isTimerPaused, ...props}: QuizHeaderProps) {
  const format = useIntl().formatNumber;

  const t = useTranslate();
  const currentQuestion = useTriviaStore((state) => state.answeredQuestions + 1);
  const noOfQuestions = useTriviaStore((state) => state.challenge?.no_of_questions!);

  return (
    <Flex align="center" justify="center" flexDir="column" mt="3.5" gap="3" mx="2.5" {...props}>
      <Flex
        w={['100%', null, '75%', '45%']}
        bg="#2A2E3A"
        boxShadow="0px 4px 12px rgba(42, 46, 58, 0.4)"
        rounded="38px"
        height="56px"
        align="center"
        justify="space-between"
        px="2"
        py="1.5"
      >
        <Text fontSize="xl" lineHeight="27px" color="white" fontWeight="bold" ms="4">
          {t('app.trivia')}
        </Text>

        <Flex gap="2" alignItems="center" bg="black" rounded="30px" py="1" px="4">
          <Image src={targetImg.src} alt="" h="30px" w="auto" />
          <Flex gap="1.5" alignItems="center">
            <Text fontSize="24px" fontWeight="700" color="#FFF3CD">
              {format(currentQuestion)}
            </Text>
            <Text fontWeight="700" fontSize="18px" color="white">
              / {format(noOfQuestions)}
            </Text>
          </Flex>
        </Flex>
      </Flex>

      <QuestionTimer isPaused={isTimerPaused} onTimeOut={onTimeOut} />
    </Flex>
  );
}
